import {
  ActionCategory,
  ActionRef,
  ActionTransactionSubType,
  ActionTransactionSubTypes,
  ActionType,
  ActionTypes,
} from 'further-types/lp/action';
import {
  ActionTransactionSubTypeLabels,
  ActionTypeLabels,
} from 'further-ui/labels';
import { isFxOnReconciliationPartialRow } from './accountMappingRowVisibility';

export const getActionLabel = (row: {
  actionRef?: ActionRef;
  actionCategory?: ActionCategory | null;
  actionType: ActionType;
  transactionSubType: ActionTransactionSubType;
  customActionType?: string | null;
  debitTransactionTypeId?: string | null;
  creditTransactionTypeId?: string | null;
}) => {
  switch (row.actionCategory) {
    case ActionCategory.FX:
      return overrideFxCategoryLabel(row);
    case ActionCategory.CapitalActions: {
      return composeSubTypeLabel(row);
    }
    case ActionCategory.Realisation:
      return showTransactionSubType(row.transactionSubType);
    default:
      return `${
        row.customActionType
          ? row.customActionType
          : ActionTypeLabels[row.actionType]
      } ${showTransactionSubType(row.transactionSubType)}`;
  }
};

export const overrideFxCategoryLabel = (row: {
  transactionSubType: ActionTransactionSubType;
  actionType: ActionType;
}) => {
  switch (row.transactionSubType) {
    case ActionTransactionSubTypes.FXGainPayable:
      return 'Unrealised FX Gain (FX Gain on payable)';
    case ActionTransactionSubTypes.FXGainReceivable:
      return 'Unrealised FX Gain (Fx Gain on receivable)';
    case ActionTransactionSubTypes.RealisedFXGain:
      return 'Realised FX gain (Payables and receivables)';
    case ActionTransactionSubTypes.UnrealisedAssetFXGain:
      return 'Unrealised Investment FX Gain (Unrealised Investment FX Gain)';
    case ActionTransactionSubTypes.UnrealisedAssetFXLoss:
      return 'Unrealised Investment FX Loss (Unrealised Investment FX Loss)';
    case ActionTransactionSubTypes.UnrealisedCashFXGain:
      return 'Unrealised Cash FX Gain (Unrealised Cash FX Gain)';
    default:
      return composeSubTypeLabel(row);
  }
};

const composeSubTypeLabel = (row: {
  transactionSubType: ActionTransactionSubType;
  actionType: ActionType;
}) => {
  const subTypeLabel = showTransactionSubType(row.transactionSubType);
  return subTypeLabel
    ? `${ActionTypeLabels[row.actionType]} (${subTypeLabel})`
    : ActionTypeLabels[row.actionType];
};

const showTransactionSubType = (
  transactionSubType: ActionTransactionSubType,
) => {
  switch (transactionSubType) {
    case ActionTransactionSubTypes.CreditDebitPair:
      return '';
    default:
      return `${ActionTransactionSubTypeLabels[transactionSubType]}`;
  }
};

const inferredOppositeTooltip = 'This will be reversed for losses.';

export const getActionTooltip = (row: {
  actionRef: ActionRef;
  actionCategory?: ActionCategory | null;
  actionType: ActionType;
  transactionSubType: ActionTransactionSubType;
  debitTransactionTypeId?: string | null;
  creditTransactionTypeId?: string | null;
}): string | undefined => {
  if (isFxOnReconciliationPartialRow(row)) {
    return inferredOppositeTooltip;
  }

  const isReversedMapping =
    row.actionType === ActionTypes.CompanyRevaluationUp ||
    row.actionType === ActionTypes.UnrealisedAssetFXGain ||
    row.actionType === ActionTypes.UnrealisedAssetFXLoss ||
    row.actionType === ActionTypes.CurrencySaleGain ||
    row.transactionSubType ===
      ActionTransactionSubTypes.UnrealisedGainsUnwind ||
    row.transactionSubType === ActionTransactionSubTypes.UnrealisedCashFXGain ||
    row.transactionSubType === ActionTransactionSubTypes.RealisedFXGain ||
    row.transactionSubType === ActionTransactionSubTypes.RealisedFXLoss;

  if (isReversedMapping) {
    return inferredOppositeTooltip;
  }

  return undefined;
};
